import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  timeLeft: null,
  timeLeftString: null,
  endDate: null,
};

const slice = createSlice({
  name: 'timer',
  initialState: reHydrateStore('booking') || initialState,
  reducers: {
    setTimeLeft: (state, { payload }) => ({
      ...state,
      timeLeft: payload,
    }),
    setTimeLeftString: (state, { payload }) => ({
      ...state,
      timeLeftString: payload,
    }),
    setEndDate: (state, { payload }) => ({
      ...state,
      endDate: payload,
    }),
    restore: () => initialState,
  },
});

export const { setTimeLeft, setTimeLeftString, setEndDate, restore } =
  slice.actions;

export default slice.reducer;
